<template>
  <div />
</template>
<script>
export default {
    name: "FilterLoader",
    mounted ()
    {
        const $card = $(".card")

        $card.click(function ()
        {
            const thisCard = $(this)

            thisCard.attr("tabindex", 1).focus()
            thisCard.toggleClass("active")

            const dropdown = thisCard.find(".filter-content")

            dropdown.toggle(0)

            const topBarHeight = $(".top-bar").height()
            const relativeOffset = dropdown.offset().top - $(window).scrollTop() - topBarHeight
            const windowHeight = $(window).height()

            if ((relativeOffset > (windowHeight - topBarHeight) / 2) && (windowHeight - relativeOffset - topBarHeight < dropdown.height()) && $(window).width() < 991)
            {
                thisCard.addClass("reverse")
            }
            else
            {
                thisCard.removeClass("reverse")
            }
        })
        $card.focusout(function ()
        {
            const thisCard = $(this)

            thisCard.removeClass("active")
            thisCard.removeClass("reverse")
            thisCard.find(".filter-content").hide()
        })
    }
}
</script>
